import React from 'react';
import { inject, observer } from 'mobx-react';
import packageJson from '../../package.json';

const Footer = ({ data }) => {
  return (
    <footer>
      Copyright (c) XPENS.AI 2021.  {data.t.read("rights_reserved")} Version {packageJson.version}
    </footer>
  );
};

export default inject("data")(observer(Footer));
